<template>
  <div class="hoverSelect">
    <div class="btncubes" :style="{zIndex: 5}">
      <template v-for="(item, i) in options">
        <div class="btncube" @click.stop="$emit('input', item)" :style="{backgroundColor: /快速預約/.test(item) ? 'var(--color-pri)' : `var(--${item})`}"  v-if="item!==defaultValue" :key="i">{{item}}</div>
      </template>
    </div>
    <div class="btncube" :style="{zIndex: 4, backgroundColor: `var(--${defaultValue})`}">{{defaultValue}}</div>
  </div>
</template>

<script>
export default {
  props: ['defaultValue', 'options']

}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.hoverSelect {
  height: 40px;
  position: relative;
  z-index: 2;
  .btncubes {
    z-index: 3;
    position: relative;
    display: none;
    width: 0;
  }
  &:hover .btncubes {
    position: absolute;
    display: flex;
    top: -10px;
    bottom: -10px;
    align-items: center;
    left: 100px;
    padding-left: 10px;
    gap: 10px;
    width: fit-content;
    z-index: 3;
    &>div{
      box-shadow: 2px 1px 2px rgba(0, 0, 0, 0.25);
      position: relative;
      z-index: 4;
    }
  }
}
.btncube {
  z-index: 4;
  width: fit-content;
  min-width: 100px;
  height: 40px;
  background: #517FA4;
  border-radius: 20px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 0.1em;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  white-space: nowrap;
  padding: 0 0.75em;
}
</style>
